<!--
  Right column of a split history layout: external comments only (transparent).
  Parent supplies full-width heading + internal column; no disclosure checkbox here.
-->
<template>
  <div class="workpermit-content-slot__history-split-right">
    <div class="workpermit-content-slot__history-external">
      <WpHistoryExternalCommentBlock
        :text="externalDisplayText"
      />
    </div>
  </div>
</template>

<script>
import WpHistoryExternalCommentBlock from './WpHistoryExternalCommentBlock'

export default {
  name: 'WpHistoryExternalCommentsColumn',
  components: {
    WpHistoryExternalCommentBlock,
  },
  props: {
    externalDisplayText: {
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.workpermit-content-slot__history-split-right {
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.workpermit-content-slot__history-external {
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  padding: 0;
}
</style>
